import styled, { css } from 'styled-components';
import LinkHandler from '../link-handler/index';

import {
  getBackgroundColor,
  getColor,
  getColorHover,
  getBorder,
  getPadding,
  getBackgroundColorHover,
  getBorderHover,
  getHeightWidth,
  getFocusStyles,
} from './buttons-factory';

export const buttonStyles = css`
  display: inline-block;
  text-align: center;
  text-decoration: none;
  border-style: none;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  padding: ${(props) => getPadding(props)};
  background-color: ${(props) => getBackgroundColor(props)};
  box-shadow: ${(props) => getBorder(props)};
  color: ${(props) => getColor(props)};

  ${({ $fullWidth }) => $fullWidth && 'width: 100%'};

  ${({ $iconPlacement, $size }) =>
    $iconPlacement === 'center' &&
    css`
      min-width: ${getHeightWidth({ $size })};
      min-height: ${getHeightWidth({ $size })};
    `};

  &:visited {
    color: ${(props) => getColor(props)};
  }

  &:focus,
  &:hover {
    color: ${(props) => getColorHover(props)};
    background-color: ${(props) => getBackgroundColorHover(props)};
    box-shadow: ${(props) => getBorderHover(props)};
    text-decoration: none;

    &:visited {
      color: ${(props) => getColorHover(props)};
    }

    ${({ disabled }) =>
      !disabled &&
      css`
        cursor: pointer;
      `}
  }

  &:focus {
    ${(props) => getFocusStyles(props)}
  }
`;

/**
 * Removes all user agent styles from a button
 */
export const buttonReset = css`
  padding: 0;
  border: none;
  font: inherit;
  color: inherit;
  background-color: transparent;
  cursor: pointer;
`;

export const SignUpLink = styled(LinkHandler)`
  ${buttonStyles};
  border: 4px solid ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.white};
  text-decoration: none;
  transition: all 0.2s ease-out;

  &:focus,
  &:hover {
    color: ${({ theme }) => theme.palette.standardText};
    background-color: ${({ theme }) => theme.palette.white};
  }
`;
